module.exports = __webpack_public_path__ + "img/Leonor Rothes.a905ecad.png";